<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
  export default {
    created() {
      this.getPageInfo();
    },
    methods: {
      getPageInfo() {
        this.$http.get(this.$api.pageInfoApi.getFooterInfo).then(({ data }) => {
          this.$store.commit("updatePageInfo", data.data);
          document.title = data.data.systemName;
        });
      }
    },
  };
  </script>
<style lang="scss"></style>

